export default __webpack_public_path__ + "static/media/logo_Recodme.1256b855.svg";